class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
    this.summaryToggle.addEventListener('keyup', (event) => {
      if (!this.isOpen() || !['ENTER', 'SPACE'].includes(event.code.toUpperCase())) return;
      this.detailsContainer.querySelector('input:not([type="hidden"])')?.focus();
    });
    this.querySelector('button[type="button"]').addEventListener(
      'click',
      this.close.bind(this)
    );

    this.summaryToggle.setAttribute('role', 'button');
    this.summaryToggle.setAttribute(
      'aria-expanded',
      this.detailsContainer.hasAttribute('open') ? 'true' : 'false'
    );

    const dialog = this.detailsContainer.querySelector('[role="dialog"]');
    if (dialog?.id) this.summaryToggle.setAttribute('aria-controls', dialog.id);
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    this.summaryToggle.setAttribute('aria-expanded', 'true');
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    const focusContainer = this.detailsContainer.querySelector('[tabindex="-1"]');
    const focusTarget = this.detailsContainer.querySelector('input:not([type="hidden"])');
    trapFocus(focusContainer, focusTarget);

    // Enter/Space activation can restore focus to the summary after its click
    // event. Reassert the intended dialog focus after that key sequence ends.
    const ensureDialogFocus = () => {
      const activeElement = document.activeElement;
      const focusEscaped = !activeElement || !this.detailsContainer.contains(activeElement);
      if (this.isOpen() && focusTarget && (activeElement === this.summaryToggle || focusEscaped)) {
        focusTarget.focus();
      }
    };
    [0, 100, 300, 700].forEach((delay) => window.setTimeout(ensureDialogFocus, delay));
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    this.summaryToggle.setAttribute('aria-expanded', 'false');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
